/* PadelPro Premium 2.0 — JavaScript sin dependencias */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (message, showLink = true) => {
    const el = $('#PpToast');
    if (!el) return;
    $('[data-toast-message]', el).textContent = message;
    $('.pp-toast__link', el).hidden = !showLink;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3500);
  };

  /* ---------- Contador del carrito ---------- */
  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };
  const refreshCartCount = async () => {
    try {
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      setCartCount(cart.item_count);
    } catch (e) { /* sin conexión */ }
  };

  /* ---------- Agregar al carrito (AJAX) ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.ajax-add, form.ajax-product-form');
    if (!form) return;
    event.preventDefault();
    const button = $('button[type="submit"]', form);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      toast('Agregado al carrito');
      refreshCartCount();
    } catch (error) {
      toast(error.message || 'No se pudo agregar. Intenta de nuevo.', false);
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        if (!button.hasAttribute('data-unavailable')) button.disabled = false;
      }
    }
  });

  /* ---------- Cantidad (+ / −) ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-qty]'));
    const min = Number(input.min || 0);
    const next = Number(input.value || 0) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Menú móvil ---------- */
  const drawer = $('[data-menu-drawer]');
  const menuOpen = $('[data-menu-open]');
  const lockScroll = (lock) => { document.documentElement.style.overflow = lock ? 'hidden' : ''; };
  const closeMenu = () => {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    lockScroll(false);
    menuOpen?.setAttribute('aria-expanded', 'false');
    menuOpen?.focus();
  };
  menuOpen?.addEventListener('click', () => {
    drawer.hidden = false;
    lockScroll(true);
    menuOpen.setAttribute('aria-expanded', 'true');
    $('[data-menu-close]', drawer.querySelector('.drawer__panel'))?.focus();
  });
  $$('[data-menu-close]').forEach((el) => el.addEventListener('click', closeMenu));

  /* ---------- Búsqueda predictiva ---------- */
  const searchPanel = $('[data-search-panel]');
  const searchOpen = $('[data-search-open]');
  const searchInput = $('[data-predictive-search]');
  const searchResults = $('[data-predictive-results]');
  const closeSearch = () => {
    if (!searchPanel || searchPanel.hidden) return;
    searchPanel.hidden = true;
    searchOpen?.setAttribute('aria-expanded', 'false');
  };
  searchOpen?.addEventListener('click', () => {
    const open = searchPanel.hidden;
    searchPanel.hidden = !open;
    searchOpen.setAttribute('aria-expanded', String(open));
    if (open) searchInput?.focus();
  });
  $('[data-search-close]')?.addEventListener('click', closeSearch);

  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let searchTimer;
  let searchController;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      searchController?.abort();
      searchController = new AbortController();
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const data = await fetch(url, { signal: searchController.signal }).then((r) => r.json());
        const products = data.resources.results.products || [];
        if (!products.length) {
          searchResults.innerHTML = `<p class="predictive-all">Sin resultados para “${escapeHtml(q)}”.</p>`;
          return;
        }
        searchResults.innerHTML = products.map((p) => `
          <a class="predictive-item" href="${escapeHtml(p.url)}">
            ${p.image ? `<img src="${escapeHtml(p.image + (p.image.includes('?') ? '&' : '?') + 'width=120')}" alt="" width="56" height="56" loading="lazy">` : ''}
            <span><strong>${escapeHtml(p.title)}</strong><span>${escapeHtml(formatPrice(p.price))}</span></span>
          </a>`).join('') +
          `<p class="predictive-all"><a class="link-arrow" href="${root}search?type=product&q=${encodeURIComponent(q)}">Ver todos los resultados</a></p>`;
      } catch (e) { /* búsqueda cancelada */ }
    }, 220);
  });
  const formatPrice = (value) => {
    const n = Number(value);
    if (Number.isNaN(n)) return value;
    return 'Q' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  /* ---------- Escape cierra paneles ---------- */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenu();
    closeSearch();
    closeFilters();
  });

  /* ---------- Filtros de colección ---------- */
  const filterForm = $('[data-filter-form]');
  const filters = $('[data-filters]');
  const filtersOpen = $('[data-filters-open]');
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  function closeFilters() {
    if (!filters?.classList.contains('is-open')) return;
    filters.classList.remove('is-open');
    lockScroll(false);
    filtersOpen?.setAttribute('aria-expanded', 'false');
  }
  filtersOpen?.addEventListener('click', () => {
    filters.classList.add('is-open');
    lockScroll(true);
    filtersOpen.setAttribute('aria-expanded', 'true');
  });
  $$('[data-filters-close]').forEach((el) => el.addEventListener('click', closeFilters));
  if (filterForm) {
    filterForm.addEventListener('change', (event) => {
      // Orden: siempre envía. Casillas: en escritorio envía al instante; en móvil espera "Ver resultados".
      if (event.target.name === 'sort_by' || (event.target.matches('[data-autosubmit]') && isDesktop())) {
        filterForm.requestSubmit();
      }
    });
    filterForm.addEventListener('submit', () => {
      $$('input[type="number"]', filterForm).forEach((input) => { if (input.value === '') input.disabled = true; });
    });
    // En escritorio solo un desplegable abierto a la vez
    $$('.filter', filterForm).forEach((d) => d.addEventListener('toggle', () => {
      if (d.open && isDesktop()) $$('.filter[open]', filterForm).forEach((o) => { if (o !== d) o.open = false; });
    }));
    document.addEventListener('click', (event) => {
      if (isDesktop() && !event.target.closest('.filter')) $$('.filter[open]', filterForm).forEach((o) => { o.open = false; });
    });
  }

  /* ---------- Carrito: actualiza al cambiar cantidad ---------- */
  const cartForm = $('#CartForm');
  if (cartForm) {
    let cartTimer;
    cartForm.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-qty]')) return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(() => $('[data-cart-update]', cartForm)?.click(), 450);
    });
  }

  /* ---------- Página de producto ---------- */
  const productSection = $('[data-product-section]');
  if (productSection) initProduct(productSection);

  function initProduct(section) {
    const form = $('.ajax-product-form', section);
    const json = $('[data-product-json]');
    const track = $('[data-gallery-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const counter = $('[data-gallery-current]', section);
    const slides = track ? $$('.gallery__slide', track) : [];

    /* Galería */
    const goTo = (index) => {
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      goTo(slides.findIndex((s) => s.dataset.mediaId === thumb.dataset.thumb));
    }));
    if (track && slides.length > 1) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = slides.indexOf(entry.target);
          if (counter) counter.textContent = index + 1;
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach((s) => observer.observe(s));
    }

    if (!form || !json) return;
    const { variants, moneyFormat } = JSON.parse(json.textContent);
    const idInput = $('[data-variant-id]', form);
    const stock = $('[data-stock-status]', form);
    const addButton = $('[data-add-to-cart]', form);
    const payment = $('[data-payment-button]', form);
    const priceBox = $('[data-product-price]', section);
    const stickyBar = $('[data-sticky-buy]');
    const stickyPrice = $('[data-sticky-price]');
    const stickyAdd = $('[data-sticky-add]');
    const optionInputs = $$('input[type="radio"][name^="options["]', form);
    const fieldsets = $$('fieldset', form);

    const formatMoney = (cents) => {
      const value = (cents / 100);
      const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const type = match ? match[1] : 'amount';
      const fixed = (decimals, thousands, decimal) => {
        const [int, dec] = value.toFixed(decimals).split('.');
        return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
      };
      const formatted = {
        amount: fixed(2, ',', '.'),
        amount_no_decimals: fixed(0, ',', '.'),
        amount_with_comma_separator: fixed(2, '.', ','),
        amount_no_decimals_with_comma_separator: fixed(0, '.', ','),
      }[type] || fixed(2, ',', '.');
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, formatted).replace(/<[^>]*>/g, '');
    };

    const selectedOptions = () => fieldsets.map((f) => $('input:checked', f)?.value);
    const findVariant = () => {
      // Productos sin opciones: Liquid ya eligió la variante correcta.
      if (!optionInputs.length) return variants.find((v) => String(v.id) === idInput.value) || variants[0];
      const opts = selectedOptions();
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    };

    const renderPrice = (variant) => {
      if (!priceBox) return;
      const sale = variant.compare_at_price > variant.price;
      priceBox.innerHTML = `
        <div class="price price--large${sale ? ' price--sale' : ''}">
          <span class="price__current">${formatMoney(variant.price)}</span>
          ${sale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>
          <span class="price__saving">Ahorras ${formatMoney(variant.compare_at_price - variant.price)}</span>` : ''}
        </div>`;
    };

    const setAvailability = (available, label) => {
      if (addButton) {
        addButton.disabled = !available;
        addButton.toggleAttribute('data-unavailable', !available);
        addButton.textContent = available ? 'Agregar al carrito' : label;
      }
      if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = available ? 'Agregar' : label; }
      if (payment) payment.hidden = !available;
    };

    const update = () => {
      const variant = findVariant();
      fieldsets.forEach((f) => {
        const out = $('[data-option-selected]', f);
        const checked = $('input:checked', f);
        if (out && checked) out.textContent = checked.value;
      });
      if (!variant) {
        idInput.value = '';
        stock.innerHTML = 'Combinación no disponible';
        stock.classList.add('is-out');
        setAvailability(false, 'No disponible');
        return;
      }
      idInput.value = variant.id;
      renderPrice(variant);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      stock.classList.toggle('is-out', !variant.available);
      stock.innerHTML = variant.available ? '<span class="stock-dot" aria-hidden="true"></span>Disponible' : 'Agotado';
      setAvailability(variant.available, 'Agotado');

      // Disponibilidad de cada opción según la selección actual
      fieldsets.forEach((fieldset, index) => {
        $$('input[type="radio"]', fieldset).forEach((radio) => {
          const test = selectedOptions();
          test[index] = radio.value;
          const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
          radio.closest('label')?.classList.toggle('is-unavailable', !(match && match.available));
        });
      });

      if (optionInputs.length) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        if (variant.featured_media) goTo(slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id)));
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', update));
    if (optionInputs.length) update();

    /* Barra fija en móvil */
    if (stickyBar && addButton) {
      stickyBar.hidden = false;
      const io = new IntersectionObserver(([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      io.observe(addButton);
      stickyAdd?.addEventListener('click', () => {
        if (!stickyAdd.disabled) form.requestSubmit(addButton);
      });
    }
  }

  /* ---------- Recomendaciones ---------- */
  const recs = $('[data-recommendations]');
  if (recs && !recs.querySelector('.product-grid')) {
    fetch(recs.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const tpl = document.createElement('div');
        tpl.innerHTML = html;
        const fresh = tpl.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) recs.innerHTML = fresh.innerHTML;
        else recs.hidden = true;
      })
      .catch(() => { recs.hidden = true; });
  }
})();
